import React, { useMemo, useState } from 'react'
import NavBar from '../components/nav-bar/Nav'
import SideBar from '../components/Sidebar'
import PageHeader from '../components/layout/PageHeader'
import EmailGrab from '../components/Hero/EmailGrab'
import HomePageGrid from '../components/Hero/HomePageGrid'
import SectorFilter from '../components/Projects/SectorFilter'
import { Band, BandInner } from '../components/Hero/HeroElements'
import { Helmet } from 'react-helmet-async'
import { Projects } from '../data/HeroSpotlight'
import { groupsFor, sectorsFrom } from '../data/sectors'

export default function ProjectsPage() {
  const [isOpen, setIsOpen] = useState(false)
  const [sector, setSector] = useState(null)
  const toggle = () => setIsOpen(!isOpen)

  const sectors = useMemo(() => sectorsFrom(Projects), [])
  const visible = useMemo(
    () => (sector ? Projects.filter((p) => groupsFor(p.companyType).includes(sector)) : Projects),
    [sector]
  )

  return (
    <>
      <Helmet>
        <title>Portfolio | Vitalforce</title>
      </Helmet>

      <SideBar $isopen={isOpen} toggle={toggle} />
      <NavBar toggle={toggle} />

      <PageHeader
        eyebrow="Portfolio"
        title="The companies we build with."
        lede="Consumer, manufacturing and media businesses making durable products — backed early and held for the long run."
      />

      <Band>
        <BandInner>
          <SectorFilter
            sectors={sectors}
            active={sector}
            onChange={setSector}
            total={Projects.length}
          />
          <HomePageGrid Projects={visible} limit={visible.length} />
        </BandInner>
      </Band>

      <EmailGrab />
    </>
  )
}
